import React, { ChangeEvent } from "react";
import { Form } from "react-bootstrap";
import { ModelOption } from "../../types/shared.types";
import { defaultAnalysisModels } from "../../utils/helpers";

interface ModelSelectorProps {
  label?: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
  models?: ModelOption[];
  controlId?: string;
  className?: string;
}

const ModelSelector: React.FC<ModelSelectorProps> = ({
  label = "Select Model:", // Default label
  value,
  onChange,
  models = defaultAnalysisModels, // Default to standard models
  controlId = "modelSelect", // Default control ID
  className = "mb-3", // Default margin
}) => {
  return (
    <Form.Group controlId={controlId} className={className}>
      <Form.Label>{label}</Form.Label>
      <Form.Select value={value} onChange={onChange}>
        {models.map((model) => (
          <option key={model.value} value={model.value}>
            {model.label}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};

export default ModelSelector;
